import { Spin } from 'antd';
import * as React from 'react';

interface FCProps {
  loading: boolean;
  message?: string;
}

const StepLoaderWrapper: React.FC<React.PropsWithChildren<FCProps>> = ({
  children,
  loading,
  message = 'Loading ...'
}) => {
  const loadingRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (loading && loadingRef.current) {
      loadingRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  }, [loading]);

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div className="absolute w-full h-full z-40 flex items-center justify-center top-0 left-0 cursor-not-allowed pointer-events-none">
          <div
            ref={loadingRef}
            className="w-[60%] h-auto bg-white flex flex-col items-center justify-center p-8 pb-4 rounded-sm"
            style={{ boxShadow: '0px 0px 15px 2px rgba(0,0,0,0.4)' }}>
            <Spin tip="Loading" size="large" />
            <p
              className="text-black text-center"
              style={{
                fontSize: 20,
                lineHeight: '30px',
                textShadow: '1px 0px 2px #fff'
              }}>
              {message}
            </p>
          </div>
        </div>
      )}
      <div
        className={
          loading ? 'pointer-events-none cursor-default select-none' : ''
        }
        style={
          loading
            ? {
                filter: 'blur(5px)',
                backgroundColor: 'rgba(255, 255, 255, 0.5)'
              }
            : {}
        }>
        {children}
      </div>
    </div>
  );
};

export default StepLoaderWrapper;
